import { useState, useEffect, useContext } from "react";
import PageSection from "../Layout/PageSection";
import StatementItem from "../Layout/StatementItem";
import Context from "../../../context";
import { API_URL, PAGINATION_LIST } from "../../data/constants";
import axios from "axios";
import Pagination from "../Layout/Pagination";

export default function StatementList () {
    const { contextState, setContextState } = useContext(Context);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [numItems, setNumItems] = useState(0);
    const [currentStatements, setCurrentStatements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState();

    let account = contextState.currentAccount;

    useEffect(() => {
        setIsLoading(true);
        axios
            .post(
                API_URL + "/Statements/History",
                {
                    pageNumber: currentPage,
                    pageSize: perPage,
                    customerId: account?.customer?.customerId,
                    customerNumber: account?.customerNumber,
                    masterCustomerId: null,
                    userName: null,
                },
                {
                    headers: {
                        Authorization: localStorage.getItem("accessToken"),
                    },
                }
            )
            .then((res) => {
                setNumItems(res.data.recordCount);
                setCurrentStatements(res.data.statements);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [perPage, currentPage]);
    
    return (
        <>
        {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border mr-4" role="status"/>
                <h4>Loading Statements...</h4>
            </div>
        ) : (
        <PageSection sectionName="Statement History">
            <ul className="statement-item-list">
                {currentStatements?.map((statement, id) => {
                    return <StatementItem key={id} statement={statement} setSelectedItem={setSelectedItem}/>;
                })}
            </ul>
            <div className="col"></div>
            <div className="pagination-container row">
                <Pagination
                    currentPage={currentPage}
                    perPage={perPage}
                    numItems={numItems}
                    paginate={paginate}
                />
                <div className="col-sm">
                    <div className="form-section">
                        <div className="form-group">
                            <label className="form-label"></label>
                            <select
                                className="form-control dropdown"
                                placeholder="Select"
                                onChange={(e) => setPerPage(e.target.value)}>
                                {PAGINATION_LIST.map((value, index) => {
                                    return (
                                        <option value={value.value} key={index}>
                                            {value.text}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </PageSection>
        )}
        </>
    );

    function paginate(num) {
        setCurrentPage(num);
    }
}
